import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'exit-game-dialog',
  templateUrl: 'exit-game-dialog.html',
})
export class ExitGameDialog {
  constructor(private dialogRef: MatDialogRef<ExitGameDialog>) {}

  yes(): void {
    this.dialogRef.close(true);
  }
}
